import type { ProfileView } from '@/viewmodel/features/user/types';

export function initialsOf(name: string): string {
  const initials = name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word[0] ?? '')
    .join('')
    .toUpperCase();

  return initials || '?';
}

export function formatMemberSince(dateStr: string, locale: string): string {
  return new Date(dateStr).toLocaleDateString(locale, { month: 'long', year: 'numeric' });
}

export function toProfileView(
  user: { name?: string; email?: string; created_at?: string } | null | undefined,
  locale: string,
): ProfileView {
  const name = user?.name ?? '';

  return {
    name,
    email: user?.email ?? '',
    initials: initialsOf(name),
    memberSince: user?.created_at ? formatMemberSince(user.created_at, locale) : null,
  };
}
